import React from 'react'

import * as Highcharts from 'highcharts';

import HighchartsReact from 'highcharts-react-official'


const CustomerWiseRenevuCount = ({ datalist }) => {



    const chatvalue = datalist?.CustomerWiseRevenuCount?.map(item => {


        return {
            name: item.name,
            y: item.transaction_count,
            color: '#166BCE'

        }

    })


    const options = {
        chart: {
            type: 'column'
        },
        title: {
            align: 'left',
            text: 'Customer wise Revenue'
        },
        subtitle: {
            align: 'left',

        },
        accessibility: {
            announceNewData: {
                enabled: true
            }
        },
        xAxis: {
            type: 'category'
        },
        yAxis: {
            title: {
                text: ''
            }

        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y:.1f}'
                }
            }
        },

        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
        },

        series: [
            {
                name: 'Customer Wise revenu Count',
                colorByPoint: true,
                data: chatvalue,
            }
        ],
    };

    return (

        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />


    )
}

export default CustomerWiseRenevuCount;